export default el => {
	const input = el.querySelector('input');
	const text = el.querySelector('.js-input-file-text');
	const format = el.querySelector('.js-input-file-format');
	const size = el.querySelector('.js-input-file-size');

	const btnRemove =  el.querySelector('.js-input-file-btn-remove');

	if (!input || !text) return;

	el.addEventListener('change', () => {
		text.innerHTML = input.files[0].name;
		size.innerHTML = convertSize(input.files[0].size);
		format.innerHTML = input.files[0].name.substring(input.files[0].name.lastIndexOf('.') + 1);

		el.classList.add('active');

		console.log(input.files[0]);
	})

	if (btnRemove) {
		btnRemove.addEventListener('click', () => {
			input.value = "";
			el.classList.remove('active');
		})
	}

	const convertSize = (n) => {
		if (n == 0) return n;

		n = Math.abs(parseInt(n, 10));
		var def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']];

		for(var i = 0; i < def.length; i++){
			if (n < def[i][0]) return ( n / def[i - 1][0]).toFixed(2) + def[i - 1][1];
		}
	}
};

